export const ACTION = {
    SET_PAGE: "SET_PAGE",
    PAGE_INCR: "PAGE_INCR",
    SET_COMMENTS: "SET_COMMENTS",
    APPEND_COMMENTS: "APPEND_COMMENTS",
    SET_COMMENT_COUNT: "SET_COMMENT_COUNT",
    INCR_COMMENT_COUNT: "INCR_COMMENT_COUNT",
    THUMBUP_THREAD: "THUMBUP_THREAD",
    THUMBUP_THREAD_REPLY: "THUMBUP_THREAD_REPLY",
    REFRESH_THREAD: "REFRESH_THREAD",
    TOGGLE_SORTING_METHOD: "TOGGLE_SORTING_METHOD",
};
